module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Remove","dialogTitle1":"Activate","notifyRemove":"Removed successfully","notifyActive":"Activated successfully"},"es":{"dialogTitle":"Eliminar","dialogTitle1":"Activar","notifyRemove":"Eliminado con éxito","notifyActive":"Activado con éxito"}}')
  delete Component.options._Ctor
}
